import * as signalR from '@aspnet/signalr'
import $util from './common'
import store from '../../store'

let uId, uName, connection, referer;
let lockReconnect = false;
let tt = null;
// 初始化websocket
function initWebSocket() {
    //当前登录用户信息
    let loginUser = $util.getLocalStorage('userMsg');
    //判断是否登录
    if (!loginUser) {
        $util.warningMsg('登录状态已失效，请重新登录！')
        return false;
    }

    uId = loginUser.EmployeeId;
    let avatarUrl = loginUser.EmployeeAvatar;
    let EntpType = loginUser.EntpType;
    let token = $util.getCookie('Token') ? $util.getCookie('Token') : ''
    referer = '-1';
    //判断企业类型
    switch (EntpType) {
        case '0': //汽修厂
            referer = "5";
            break;
        case '1': //物流商
            referer = "6";
            break;
        case '2': //供应商
            referer = "7";
            break;
        case '3': //汽配商
            referer = "8";
            break;
    }
    return new Promise((resolve, reject) => {
        connection = new signalR.HubConnectionBuilder()
            .withUrl($util.CHAT_BASE_URL + `/servicehub?referer=${referer}&sessionType=41&uType=1&uid=${uId}&avatarUrl=${avatarUrl}&uName=${uName}&token=${token}`)
            .build();
        connection.start().then(() => {
            store.commit('updateConnectState', 2)
            // heartCheck.start();
            resolve(connection)
        }).catch((err) => {
            reject()
            store.commit('updateConnectState', 5)
        });
        // 监听断开
        connection.onclose(() => {
            store.commit('updateConnectState', 0);
        });

        // connection.on('HeartCheck', function (res) {
        //     heartCheck.start();
        // });

        connection.on('NoticeGroupService', function (res) {
            store.commit('updateGroupMsg', res);
        })

    })
}

// 监听断开并回调
// function onCloseWebsocket(callback) {
//     connection.onclose(() => {
//         // callback && callback()
//         heartCheck.start();
//     });
// }

// 断开连接
function closeSocket() {
    connection.stop()
}

function reconnect() {
    if (lockReconnect) {
        return;
    }
    lockReconnect = true;
    //没连接上会一直重连，设置延迟避免请求过多
    tt && clearTimeout(tt);
    tt = setTimeout(function () {
        //initWebSocket();
        store.commit('updateConnectState', 3)
        lockReconnect = false;
    }, 20000);
}

// 接收websocket信息
function receiveWebsocket(callback) {
    connection.on('NoticeCustomer', function (res) {
        callback && callback(res)
    })
}

function receivePersonalChat(callback) {
    connection.on('PersonalChat', function (res) {
        callback && callback(res)
    })
}

// function receiveGroupChat(callback) {
//     connection.on('NoticeGroupService', function (res) {
//         callback && callback(res)
//     })
// }

function receiveSystemMsg(callback) {
    connection.on('SystemMsg', function (res) {
        callback && callback(res)
    })
}

//心跳检测
let heartCheck = {
    timeout: 10000,
    timeoutObj: null,
    serverTimeoutObj: null,
    start: function () {
        var self = this;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function () {
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            //任意发一个消息过去，后台接收，在init()中的onmessage收到消息，说明后台没有挂掉，有心跳
            connection.invoke("send", "HeartCheck");
            self.serverTimeoutObj = setTimeout(function () {
                reconnect();
            }, self.timeout);

        }, this.timeout)
    }
}

// 发送websocket信息
function sendWebsocket(params, callback) {
    $util.axiosPost({
        url: '/admin/ChatCenter/SendMsgToSingle',
        data: {
            "sId": params.sId,
            "cId": $util.getLocalStorage('userMsg').EmployeeId,
            "contentType": params.contentType,
            "content": params.content,
            "sessionId": $util.getLocalStorage('sessionId'),
            "senderType": 0,
            "ObjectId": params.ObjectId,
            "CType": 1, //客户类型
            "Referer": referer
        },
        hideLoading: true,
        eipApi: true
    }).then((res) => {
        callback && callback(res)
        if (res.errcode != 0) {
            this.$util.errorMsg('发送消息失败！')
        }
    }).catch(() => {})
}
// 发送websocket信息
function sendToFriendWebsocket(params, callback) {
    $util.axiosPost({
        url: '/admin/EntpIMCenter/SendMsgToSingleFriend',
        data: {
            "cId": params.sId,
            "sId": $util.getLocalStorage('userMsg').EmployeeId,
            "contentType": params.contentType,
            "content": params.content,
            "sessionId": $util.getLocalStorage('sessionId'),
            "senderType": 0,
            "ObjectId": params.ObjectId,
            "CType": 1, //客户类型
            "Referer": referer,
            "SendData": params.sendData
        },
        hideLoading: true,
        eipApi: true
    }).then((res) => {
        callback && callback(res)
        if (res.errcode != 0) {
            this.$util.errorMsg('发送消息失败！')
        }
    }).catch(() => {})
}

function sendToServiceWebsocket(params, callback) {
    $util.axiosPost({
        url: '/admin/EntpIMCenter/SendMsgToService',
        data: {
            "cId": $util.getLocalStorage('userMsg').EmployeeId,
            "sId": params.sId,
            "contentType": params.contentType,
            "content": params.content,
            "sessionId": $util.getLocalStorage('sessionId'),
            "senderType": 0,
            "ObjectId": params.ObjectId,
            "CType": 1, //客户类型
            "Referer": referer,
            "SendData": params.sendData
        },
        hideLoading: true,
        eipApi: true
    }).then((res) => {
        callback && callback(res)
        if (res.errcode != 0) {
            this.$util.errorMsg('发送消息失败！')
        }
    }).catch(() => {})
}

function sendToEntpFriendWebsocket(params, callback) {
    $util.axiosPost({
        url: '/admin/EntpIMCenter/SendMsgToEntpFriend',
        data: {
            "cId": $util.getLocalStorage('userMsg').EmployeeId,
            "contentType": params.contentType,
            "content": params.content,
            "sessionId": $util.getLocalStorage('sessionId'),
            "senderType": 0,
            "ObjectId": params.ObjectId,
            "CType": 1, //客户类型
            "Referer": referer,
            "SendData": params.sendData
        },
        hideLoading: true,
        eipApi: true
    }).then((res) => {
        callback && callback(res)
        if (res.errcode != 0) {
            this.$util.errorMsg('发送消息失败！')
        }
    }).catch(() => {})
}

function sendProductToServiceWebsocket(params, callback) {
    $util.axiosPost({
        url: '/admin/EntpIMCenter/SendProductToService',
        data: {
            "cId": $util.getLocalStorage('userMsg').EmployeeId,
            "sId": params.sId,
            "contentType": params.contentType,
            "content": params.content,
            "sessionId": $util.getLocalStorage('sessionId'),
            "senderType": 0,
            "ObjectId": params.ObjectId,
            "CType": 1, //客户类型
            "Referer": referer,
            "SendData": params.sendData
        },
        hideLoading: true,
        eipApi: true
    }).then((res) => {
        callback && callback(res)
        if (res.errcode != 0) {
            this.$util.errorMsg('发送消息失败！')
        }
    }).catch(() => {})
}

// 通知客服消息已读
function markRead(sId) {
    $util.axiosPost({
        url: '/admin/ChatCenter/SessionContentsSetRead',
        data: {
            "sId": sId,
            "cId": $util.getLocalStorage("userMsg").EmployeeId,
            "cType": 1,
            "reciever": 0
        },
        eipApi: true,
        hideLoading: true
    }).catch(() => {})
}

function markFriendRead(fId) {
    $util.axiosPost({
        url: '/admin/EntpIMCenter/FriendSessionSetRead',
        data: {
            "SId": fId,
            "CId": $util.getLocalStorage("userMsg").EmployeeId,
            "cType": 1,
            "reciever": 0
        },
        eipApi: true,
        hideLoading: true
    }).catch(() => {})
}

function markGroupRead(fId) {
    $util.axiosPost({
        url: '/admin/EntpIMCenter/GroupSessionSetRead',
        data: {
            "SId": fId,
            "CId": $util.getLocalStorage("userMsg").EmployeeId,
            "cType": 1,
            "reciever": 0
        },
        eipApi: true,
        hideLoading: true
    }).catch(() => {})
}
export default {
    initWebSocket,
    receiveWebsocket,
    sendWebsocket,
    closeSocket,
    markRead,
    sendToFriendWebsocket,
    sendToServiceWebsocket,
    receivePersonalChat,
    receiveSystemMsg,
    markFriendRead,
    sendProductToServiceWebsocket,
    sendToEntpFriendWebsocket,
    //receiveGroupChat,
    markGroupRead
    //onCloseWebsocket
}